import React from 'react';
import { IconProps } from './types';

const ChevronIcon = ({ className }: IconProps): React.ReactElement => (
  <svg
    height="24"
    width="24"
    viewBox="-6 -6 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 6.103L3.503 5 8 9.004 12.497 5 13.5 6.103 8 11 2.5 6.103z"
    />
  </svg>
);

export default ChevronIcon;
